let didInject = false;

export function injectNbrbFont() {
  if (didInject) return;
  didInject = true;

  // Важно: в этом проекте webpack пытается резолвить шрифты в CSS, поэтому инжектим правила на runtime.
  const style = document.createElement("style");
  style.setAttribute("data-nbrb-font", "1");
  style.textContent = `
@font-face {
  font-family: "nbrb";
  src: url("/fonts/nbrb.woff2") format("woff2"),
       url("/fonts/nbrb.ttf") format("truetype"),
       url("/fonts/nbrb.woff") format("woff");
  unicode-range: U+E901, U+42, U+59, U+4E;
  font-display: swap;
}

.nbrb-icon {
  font-family: "nbrb" !important;
  speak: none;
  font-style: inherit;
  font-weight: inherit;
  font-variant: inherit;
  text-transform: none;
  line-height: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  letter-spacing: normal;
  -webkit-font-feature-settings: "liga";
  -moz-font-feature-settings: "liga=1";
  -moz-font-feature-settings: "liga";
  -ms-font-feature-settings: "liga" 1;
  font-feature-settings: "liga";
  -webkit-font-variant-ligatures: discretionary-ligatures;
  font-variant-ligatures: discretionary-ligatures;
}

.nbrb-icon-byn:before {
  content: "\\e901";
}
  `;

  document.head.appendChild(style);
}

